// Notification service for offboarding events
const API_BASE = 'https://hrms.gtplindia.com:8443';

export const offboardingNotificationAPI = {
  // Send notification when resignation is submitted
  notifyResignationSubmitted: async (empCode, managerCode, resignationData) => {
    try {
      const response = await fetch(`${API_BASE}/notifications/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          recipient_emp_code: managerCode,
          sender_emp_code: empCode,
          title: 'New Resignation Request',
          message: `${resignationData.employee_name} has submitted a resignation request. Last working day: ${resignationData.requested_lwd}`,
          type: 'resignation_submitted',
          priority: 'high',
          data: resignationData
        })
      });
      return await response.json();
    } catch (error) {
      console.error('Failed to send resignation notification:', error);
    }
  },

  // Send notification when manager approves/rejects
  notifyManagerDecision: async (empCode, decision, resignationData) => {
    try {
      const response = await fetch(`${API_BASE}/notifications/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          recipient_emp_code: empCode,
          sender_emp_code: resignationData.manager_code,
          title: `Resignation ${decision ? 'Approved' : 'Rejected'}`,
          message: decision 
            ? 'Your resignation has been approved by your manager. Please proceed with handover and asset return.'
            : `Your resignation has been rejected. Reason: ${resignationData.reason}`,
          type: 'manager_decision',
          priority: 'high',
          data: resignationData
        })
      });
      return await response.json();
    } catch (error) {
      console.error('Failed to send manager decision notification:', error);
    }
  },

  // Send notification when HR approves/rejects
  notifyHRDecision: async (empCode, managerCode, decision, resignationData) => {
    try {
      // Notify employee
      await fetch(`${API_BASE}/notifications/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          recipient_emp_code: empCode,
          sender_emp_code: 'HR001',
          title: `Final Resignation ${decision ? 'Approved' : 'Rejected'}`,
          message: decision 
            ? 'Your resignation has been fully approved! HR will send your relieving letter and experience certificate to your registered email.'
            : `Your resignation has been rejected by HR. Reason: ${resignationData.rejection_reason}`,
          type: 'hr_decision',
          priority: 'high',
          data: resignationData
        })
      });

      // Notify manager
      await fetch(`${API_BASE}/notifications/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          recipient_emp_code: managerCode,
          sender_emp_code: 'HR001',
          title: `Employee Resignation ${decision ? 'Approved' : 'Rejected'}`,
          message: `${resignationData.employee_name}'s resignation has been ${decision ? 'approved' : 'rejected'} by HR.`,
          type: 'hr_decision',
          priority: 'medium',
          data: resignationData
        })
      });
    } catch (error) {
      console.error('Failed to send HR decision notification:', error);
    }
  }
};